import React, { useEffect, useState } from "react";
import { api } from "../../../hooks/api";
import { DropdownMultiSelectMenu } from "../../DropdownMenu.tsx";
import { color } from "../../../styles";
import { FilterOption, FilterType } from "../../../../configs/filterTypes";
import { ROLE } from "../../../../data/enums";

interface StaffFilterProps {
    onChangeValue: (value: any) => void;
    isReset?: boolean;
    filterType: FilterType;
    staffRole: ROLE;
}

const StaffFilter = ({ onChangeValue, isReset, filterType, staffRole }: StaffFilterProps) => {
    const [{ data, isLoading }, fetchUsers] = api.get(`/users/?role=${staffRole}`);
    const [options, setOptions] = useState<FilterOption[]>([]);

    useEffect(() => {
        // Reset options when isReset is true
        if (isReset) {
            onChangeValue([]);
        }
    }, [isReset, onChangeValue]);

    useEffect(() => {
        // Transform users data into filter options
        if (data && data.results) {
            const userOptions = data.results.map((user: any) => ({
                text: user.display_name || user.username,
                value: user.id,
            }));
            setOptions(userOptions);
        }
    }, [data]);

    const handleOnclickItem = (item: FilterOption, isAdded: boolean) => {
        if (isAdded) {
            onChangeValue([
                {
                    query: item.value,
                },
            ]);
        } else {
            onChangeValue([]);
        }
    };

    return (
        <DropdownMultiSelectMenu
            menuList={options}
            menuText={filterType.text}
            menuField={filterType.field}
            handleOnclickItem={handleOnclickItem}
            style={{
                height: "30px",
                fontSize: "12px",
                color: color.secondary.DARK_GREY,
            }}
            isReset={isReset}
            dataTestId={filterType.dataTestId}
        />
    );
};

export default StaffFilter; 